import React from 'react';
import { Panel, Glyphicon } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
    getSettings,
    updateSettings,
    clearUpdateSettings,
    deleteSettings,
    clearDeleteSettings
} from '../../../actions/settings';
import { Table } from './Table'
import { reviews as reviewsType } from '../../../constants/settingTypes';
import EditModal from './EditModal';
import * as permissions from '../../../constants/permissions';
import ConfirmModal from '../../common/ConfirmModal'
import moment from 'moment';
let Reviews = class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAddModal: false,
            showUpdateModal: false,
            confirmModalShow: false,
            reviewToEdit: null,
            isMultiple: true
        }
        this._load = this._load.bind(this);
        this._onAddClick = this._onAddClick.bind(this);
        this._onEditClick = this._onEditClick.bind(this);
        this._onClose = this._onClose.bind(this);
        this._addReview = this._addReview.bind(this);
        this._updateReview = this._updateReview.bind(this);
        this._onDeleteClick = this._onDeleteClick.bind(this);
        this._onDeleteCanceled = this._onDeleteCanceled.bind(this);
        this._onDeleteConfirmed = this._onDeleteConfirmed.bind(this);
    }
    componentDidMount() {
        this._load();
    }
    _load() {
        this.props.getSettings(reviewsType);
    }
    _onAddClick() {
        this.setState({ showAddModal: true });
    }
    _addReview(review) {
        this.props.updateSettings(reviewsType, review,undefined,undefined,this.state.isMultiple);
    }
    _onClose() {
        this.setState({
            showAddModal: false,
            reviewToEdit: null,
            showUpdateModal: false
        });
        this.props.clearUpdateSettings(reviewsType);
    }
    _onEditClick(review) {
        this.setState({ reviewToEdit: review, showUpdateModal: true })
    }
    
    _onDeleteClick(reviewToDelete) {
        this.setState({ reviewToDelete, confirmModalShow: true });
    }
     _onDeleteCanceled() {
        this.setState({ reviewToDelete: null, confirmModalShow: false });
        this.props.clearDeleteSettings(reviewsType);
    }
    _onDeleteConfirmed() {
        this.props.deleteSettings(reviewsType ,{Id :this.state.reviewToDelete.Id});
    }
    _updateReview(review) {
        this.props.updateSettings(reviewsType, review, review.Id, undefined,this.state.isMultiple);
    }
    render() {
        const { reviews: { data, fetching,deleteFetching } } = this.props;
        const { showAddModal, showUpdateModal, reviewToEdit } = this.state;
        const modalProps = {
            isNew: showAddModal,
            initialValues: reviewToEdit ? reviewToEdit : { IsActive: true },
            onClose: this._onClose,
            onSubmit: showAddModal ? this._addReview : this._updateReview
        };
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        const addByttonClass = `add-glyph${isReadOnly ? '.disabled' : ''}`;
        
        return (
            <Panel>
                <Panel.Heading >
                    <span>Отзывы</span>
                    <Glyphicon
                        glyph='plus'
                        title='Добавить'
                        className={addByttonClass} style={{ float: 'right' }}
                        onClick={isReadOnly ? undefined : this._onAddClick} />
                </Panel.Heading>
                <Panel.Body className='box-container'>
                    <Table
                        fetching={fetching}
                        deleteFetching={deleteFetching}
                        reviews={data}
                        onEdit={this._onEditClick}
                        onDelete ={this._onDeleteClick}
                        isReadOnly={isReadOnly} />
                    {(showAddModal || showUpdateModal) && <EditModal {...modalProps} />}
                    {this.state.confirmModalShow &&
                        <ConfirmModal
                            onYes={this._onDeleteConfirmed}
                            onNo={this._onDeleteCanceled}
                            fetching={deleteFetching}
                            message={`Удалить отзыв под Id ${moment(this.state.reviewToDelete.Id)}?`}
                            title="Вы уверены?"
                            show={true} />}
                </Panel.Body>
            </Panel>
        );
    }
}
Reviews = connect(state => {
    return { reviews: state.application.get('settings')[reviewsType] };
}, { getSettings, updateSettings, clearUpdateSettings, deleteSettings ,clearDeleteSettings})(Reviews);
export default Reviews;


// WEBPACK FOOTER //
// ./src/components/settings/reviews/Reviews.jsx